import * as React from 'react';
import { PopEdit as DesignPopEdit } from '@whalecloud/fdx';
import { RemoteComponent } from '@components/RemoteComponent';

const PopEdit = ({ element, value, onChange }) => {
  const { settings = {}, className = '' } = element.data;
  let { formItemSettings = {} } = element.data;
  const { defaultValue, modalProps: { render = '' } } = formItemSettings;
  const { width } = settings;
  value = value || formItemSettings.value;
  const handleOk = (val:any) => {
    value = val
  }
  const handleChange = val => {
    onChange(val)
  }
  const modalProps = {
    ...formItemSettings?.modalProps,
    onOk: handleOk,
  }
  formItemSettings = {
    ...formItemSettings,
    value,
    defaultValue,
    onChange: handleChange,
    modalProps: { ...modalProps },
  }
  if (render) {
    // 通过远程组件渲染 Modal
    const ModalComponent = (props: any) => <RemoteComponent url={render} {...props} />

    const hanlderComponentRender = (handleValue: any) => {
      const { value, defaultValue, dataTextField, dataValueField } = formItemSettings;
      const ModalComponentProps = { value, defaultValue, dataTextField, dataValueField }
      return (
        <ModalComponent handleValue={handleValue} {...ModalComponentProps} />
      )
    }
    formItemSettings.modalProps.render = (handleValue) => hanlderComponentRender(handleValue)
  }

  return (
    <DesignPopEdit style={{ width: width.value }} {...formItemSettings} className={className} />
  );
};

export default PopEdit;
